<div class="main-page">
  <!-- <nav class="navbar navbar-expand-lg navbar-light bg-light header">
    <a class="navbar-brand" routerLink="/profile"> <span class="nav-divnk time" ><i class="fa fa-long-arrow-left" style="font-size:48px;color:#fff;margin-top:-16px;"></i></span></a>
      <div class="form-inline my-2 my-lg-0">
        <span (click)="redirectTo()" class="nav-divnk">Subscribe</span>
    </div>
  </nav> -->
  <nav class="navbar navbar-expand-lg navbar-light bg-light header">
    <a class="navbar-brand" routerLink="/profile">
      <span class="nav-divnk time" (click)="redirectTo()">
        <img src="assets/logo-4.png" alt="Logo" /> </span
    ></a>
    <div
      class="form-inline my-2 my-lg-0"
      style="width: 100%; display: flex; margin-left: 430px; gap: 400px"
    >
      <div class="form-inline my-2 my-lg-0">
        <span class="nav-divnk">Merchant Profile</span>
      </div>
      <div class="form-inline my-2 my-lg-0">
        <span
          class="nav-divnk"
          style="cursor: pointer"
          (click)="openProfileSelectModal(content)"
          >Login</span
        >
      </div>
    </div>
  </nav>
  <div class="container">
    <ngx-ui-loader fgsSize="50" [fgsType]="spinnerType"></ngx-ui-loader>
    <div class="row banner" style="padding-top: 30px">
      <img
        [src]="setUrl(user?.coverPhoto)"
        style="width: 100%; height: 300px"
      />
    </div>
    <div class="row profile">
      <div style="position: absolute; translate: 45px -115px">
        <img class="userImage" [src]="setUrl(user?.photo)" />
      </div>
      <div class="followers">
        <div class="cust-style">
          Followers<br /><span style="color: #cb6124; padding-top: 10px">{{
            user.followersCount
          }}</span>
        </div>
        <div class="cust-style">
          Visitors<br /><span style="color: #cb6124; padding-top: 10px">{{
            user.visitorsCount
          }}</span>
        </div>
        <!-- <div class="cust-style"><img src="assets/pie-chart.png" /></div>
        <div class="cust-style"><img src="assets/social.png" /></div> -->
        <div class="cust-style" (click)="copyCurrentURL()">
          <img
            src="assets/share.png"
            style="border: 0; border-radius: 0; cursor: pointer"
          />
        </div>
      </div>
    </div>
    <div class="details">
      <div class="side-container">
        <div class="discount" style="width: 700px">
          <h2
            *ngIf="user.name"
            style="font-weight: 600; text-transform: capitalize"
          >
            {{ user.name }}
          </h2>
          <p>
            <img src="assets/faithcross.png" style="margin-left: 14px" /><em>{{
              user?.logLine
            }}</em>
          </p>
          <p class="p-class" style="margin-left: 20px">
            <span>{{ user?.shortBio }}</span>
          </p>
          <p
            class="p-class"
            style="margin-left: 20px"
            *ngIf="
              user?.customCategory[1]?.title &&
              user?.customCategory[1]?.description
            "
          >
            <strong style="font-size: 20px">Our Menu:</strong>
            <br />
            <span>
              {{ user?.customCategory[1]?.title }}
              <span *ngIf="user?.customCategory[1]?.description">
                / {{ user?.customCategory[1]?.description }}</span
              >
            </span>
          </p>
          <p class="p-class" style="margin-left: 20px">
            <span
              >{{ user?.bussinessTypes[0]?.tagName }},
              {{ user?.bussinessTypes[1]?.tagName }}</span
            >
          </p>

          <p class="p-class">
            <span *ngFor="let img of user?.imageGallery">
              <img [src]="setUrl(img)" style="width: 140px" />
            </span>
          </p>
        </div>
        <div
          class="discount1"
          style="width: 300px; height: auto; margin-top: 10px"
        >
          <div
            class="labelMember"
            *ngIf="user?.perpetualAdd?.description != null"
          >
            Members Discount
          </div>
          <div
            class="discount-container1"
            [ngStyle]="{
              'background-image': 'url(' + user?.perpetualAdd?.imagePath + ')',
              'background-repeat': 'no-repeat',
              'background-size': 'cover',
              'background-position': 'center'
            }"
            *ngIf="user?.perpetualAdd?.description != null"
          >
            <div class="container1">
              <p style="background: white; border-radius: 4px; padding: 4px">
                {{ user?.perpetualAdd?.description }}
              </p>
            </div>
          </div>
          <div class="discount-container2">
            <div class="container2">
              <div class="cols">
                <div class="row">
                  <div class="col collll">
                    <div ngbDropdown class="d-inline-block" style="width: 100%">
                      <button
                        type="button"
                        class="btn dropdownBtn"
                        id="dropdownBasic1"
                        ngbDropdownToggle
                        style="
                          background-color: blue !important;
                          color: white;
                          width: 100%;
                        "
                      >
                        Contact
                      </button>
                      <div ngbDropdownMenu aria-labelledby="dropdownBasic1">
                        <button ngbDropdownItem>
                         <a [href]="'tel:' + user?.contactNo"
                          style="text-decoration: none; color: inherit"
                          (click)="trackClick('phoneClicks')"
                          >Phone</a
                        >
                      </button>
                        <button ngbDropdownItem>
                         <a [href]="'mailto:' + user?.email"
                          style="text-decoration: none; color: inherit"
                          (click)="trackClick('emailClicks')"
                          >Email</a
                        >
                      </button>

                        <button ngbDropdownItem
                        >
                        {{ user?.usersUpRating?.length > 0 ? user.usersUpRating.length : 0 }}
                            %
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <h2>Business Info</h2>
      <p class="p-class" style="margin-left: 20px">
        <ng-container *ngIf="!user?.showStreetAddress; else cityStateCountry">
          {{ user?.address?.streetAddress }}
        </ng-container>
        <ng-template #cityStateCountry>
          {{ user?.address?.city }}, {{ user?.address?.state }},
          {{ user?.address?.country }}
        </ng-template>
      </p>
      <p class="p-class" style="margin-left: 20px">
        <span>{{ user?.phonecode }}-</span>
        <span>{{ user?.contactNo }}</span>
      </p>
      <!-- <p class="p-class">
        <img class="col-md-2" src="assets/user.png" /><span></span>
      </p> -->
     <p class="p-class" style="margin-left: 20px">
        <a *ngIf="user?.website" [href]="user.website.startsWith('http') ? user.website : 'https://' + user.website"
        target="_blank" (click)="trackClick('websiteClicks')">
        {{ user.website }}
        </a>
      </p>
      <p class="p-class" style="margin-left: 20px">
        <strong style="font-size: 20px"
          >Our Values / Statement of Faith:</strong
        >
        <br />
        <span>{{ user?.menu }} </span>
      </p>
      <p class="p-class" style="margin-left: 20px">
        <span>
          {{ user?.faith?.name }}
          <ng-container *ngIf="user?.subFaith?.name">
            / {{ user?.subFaith?.name }}</ng-container
          >
          <ng-container *ngIf="user?.subFaith2?.name">
            / {{ user?.subFaith2?.name }}</ng-container
          >
        </span>
      </p>
      <p class="p-class" style="margin-left: 20px">
        <strong style="font-size: 20px">Ministry: </strong>
        <span> {{ user?.affliatedBy?.name }} </span>
      </p>

      <div class="p-class" style="margin-left: 20px" *ngIf="user?.socialMediaLinks">
        <strong style="font-size: 18px">Social Links:</strong>
        <div style="display: flex; gap: 15px; margin-top: 8px;">
          <a *ngIf="user?.socialMediaLinks?.facebook?.id"
            [href]="user.socialMediaLinks.facebook.id" target="_blank"
            (click)="trackClick('socialClicks', 'facebook')">
            <i class="fab fa-facebook"></i> Facebook
          </a>
          <a *ngIf="user?.socialMediaLinks?.instagram?.id"
            [href]="user.socialMediaLinks.instagram.id" target="_blank"
            (click)="trackClick('socialClicks', 'instagram')">
            <i class="fab fa-instagram"></i> Instagram
          </a>
          <a *ngIf="user?.socialMediaLinks?.google?.id"
            [href]="user.socialMediaLinks.google.id" target="_blank"
            (click)="trackClick('socialClicks', 'google')">
            <i class="fab fa-google"></i> Google
          </a>
          <a *ngIf="user?.socialMediaLinks?.apple?.id"
            [href]="user.socialMediaLinks.apple.id" target="_blank"
            (click)="trackClick('socialClicks', 'apple')">
            <i class="fab fa-apple"></i> Apple
          </a>
        </div>
      </div>

      <div class="p-class" style="margin-left: 20px" *ngIf="user?.iosAppLink || user?.androidAppLink">
        <strong style="font-size: 18px">Download our App:</strong>
        <div style="display: flex; gap: 15px; margin-top: 8px;">
          <a *ngIf="user?.iosAppLink" [href]="user.iosAppLink" target="_blank"
            (click)="trackClick('appStoreClicks')">
            <i class="fab fa-apple"></i> App Store
          </a>
          <a *ngIf="user?.androidAppLink" [href]="user.androidAppLink" target="_blank"
            (click)="trackClick('appStoreClicks')">
            <i class="fab fa-google-play"></i> Play Store
          </a>
        </div>
      </div>
      
      <agm-map
        *ngFor="let m of marArr; let i = index"
        [latitude]="m.lat"
        [longitude]="m.lng"
        [fullscreenControl]="true"
        [zoomControl]="true"
        [zoom]="13"
        [streetViewControl]="false"
        [mapTypeControl]="false"
      >
        <agm-marker
          [latitude]="m.lat"
          [longitude]="m.lng"
          [markerDraggable]="m.draggable"
          (dragEnd)="markerDragEnd(m, $event)"
        >
          <agm-info-window>
            <strong>{{ m?.streetAddress }}</strong
            ><br />
            <strong>{{ m?.city }}</strong
            ><br />
            <strong>{{ m?.state }}</strong
            ><br />
            <strong>{{ m?.country }}</strong
            ><br />
          </agm-info-window>
        </agm-marker>
      </agm-map>

      <button (click)="openMapForDirections(m.lat && [m.lat, m.lng])" *ngIf="marArr.length">
        Get Directions
      </button>
      <h2 style="margin-left: 66%">Business Hours</h2>
      <div
        class="container"
        style="
          display: flex;
          flex-direction: column;
          width: 360px;
          margin-left: 30px;
          float: right;
        "
      >
        <span class="font-weight-bold">Business Hours: </span>
        <ul style="list-style: none; padding: 0">
          <li style="display: flex; justify-content: space-between">
            <span>Sun</span>
            <span>
              <ng-container
                *ngIf="
                  user?.bussinessHours?.Sunday[0]?.Start &&
                    user?.bussinessHours?.Sunday[0]?.Finish;
                  else empty
                "
              >
                {{ convertToIST(user?.bussinessHours?.Sunday[0]?.Start) }} -
                {{ convertToIST(user?.bussinessHours?.Sunday[0]?.Finish) }}
              </ng-container>
              <ng-template #empty> </ng-template>
            </span>
          </li>
          <li style="display: flex; justify-content: space-between">
            <span>Mon</span>
            <span>
              <ng-container
                *ngIf="
                  user?.bussinessHours?.Monday[0]?.Start &&
                    user?.bussinessHours?.Monday[0]?.Finish;
                  else empty
                "
              >
                {{ convertToIST(user?.bussinessHours?.Monday[0]?.Start) }} -
                {{ convertToIST(user?.bussinessHours?.Monday[0]?.Finish) }}
              </ng-container>
              <ng-template #empty> </ng-template>
            </span>
          </li>
          <li style="display: flex; justify-content: space-between">
            <span>Tue</span>
            <span>
              <ng-container
                *ngIf="
                  user?.bussinessHours?.Tuesday[0]?.Start &&
                    user?.bussinessHours?.Tuesday[0]?.Finish;
                  else empty
                "
              >
                {{ convertToIST(user?.bussinessHours?.Tuesday[0]?.Start) }} -
                {{ convertToIST(user?.bussinessHours?.Tuesday[0]?.Finish) }}
              </ng-container>
              <ng-template #empty> </ng-template>
            </span>
          </li>
          <li style="display: flex; justify-content: space-between">
            <span>Wed</span>
            <span>
              <ng-container
                *ngIf="
                  user?.bussinessHours?.Wednesday[0]?.Start &&
                    user?.bussinessHours?.Wednesday[0]?.Finish;
                  else empty
                "
              >
                {{ convertToIST(user?.bussinessHours?.Wednesday[0]?.Start) }} -
                {{ convertToIST(user?.bussinessHours?.Wednesday[0]?.Finish) }}
              </ng-container>
              <ng-template #empty> </ng-template>
            </span>
          </li>
          <li style="display: flex; justify-content: space-between">
            <span>Thu</span>
            <span>
              <ng-container
                *ngIf="
                  user?.bussinessHours?.Thursday[0]?.Start &&
                    user?.bussinessHours?.Thursday[0]?.Finish;
                  else empty
                "
              >
                {{ convertToIST(user?.bussinessHours?.Thursday[0]?.Start) }} -
                {{ convertToIST(user?.bussinessHours?.Thursday[0]?.Finish) }}
              </ng-container>
              <ng-template #empty> </ng-template>
            </span>
          </li>
          <li style="display: flex; justify-content: space-between">
            <span>Fri</span>
            <span>
              <ng-container
                *ngIf="
                  user?.bussinessHours?.Friday[0]?.Start &&
                    user?.bussinessHours?.Friday[0]?.Finish;
                  else empty
                "
              >
                {{ convertToIST(user?.bussinessHours?.Friday[0]?.Start) }} -
                {{ convertToIST(user?.bussinessHours?.Friday[0]?.Finish) }}
              </ng-container>
              <ng-template #empty> </ng-template>
            </span>
          </li>
          <li style="display: flex; justify-content: space-between">
            <span>Sat</span>
            <span>
              <ng-container
                *ngIf="
                  user?.bussinessHours?.Saturday[0]?.Start &&
                    user?.bussinessHours?.Saturday[0]?.Finish;
                  else empty
                "
              >
                {{ convertToIST(user?.bussinessHours?.Saturday[0]?.Start) }} -
                {{ convertToIST(user?.bussinessHours?.Saturday[0]?.Finish) }}
              </ng-container>
              <ng-template #empty> </ng-template>
            </span>
          </li>
        </ul>
      </div>
    </div>
  </div>
</div>

<div class="modal-container">
  <ng-template #content let-modal>
    <div class="form-container">
      <div class="modalcontainer">
        <div class="row">
          <div class="col-xs-6 col-sm-12 col-md-12 Login_center">
            <div class="main_login">
              <!-- <h3 class="text-center my-4 font-weight-bold text-white">Welcome</h3> -->
              <div
                style="
                  display: flex;
                  justify-content: end;
                  color: white;
                  font-size: x-large;
                  cursor: pointer;
                "
              >
                <p (click)="modal.close()">X</p>
              </div>

              <div class="d-flex justify-content-center loginDailog-img mb-3">
                <img src="assets/logo-4.png" alt="Logo" />
              </div>

              <div class="form-group mb-3 text-center">
                <button
                  class="btn btn-success"
                  (click)="redirectTo()"
                  style="background: #eab644"
                >
                  Personal
                </button>
                <button
                  class="btn btn-success"
                  (click)="redirectTo()"
                  style="background-color: #1a8f2e"
                >
                  Merchant
                </button>
                <button
                  class="btn btn-success"
                  (click)="redirectTo()"
                  style="background-color: #0f4240"
                >
                  Ministry
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </ng-template>
</div>
